import { createSelector } from 'reselect';

export const selectedOpenedClaims = (state: any) => {
  return state.get('managerOpenedClaims');
};

export const makeSelectOpenedClaims = () =>
  createSelector(selectedOpenedClaims, claims => {
    if (claims && claims.get('claims')) {
      return claims.get('claims').toJS();
    }
    return [];
  });

export const makeSelectCountOpenedClaims = () =>
  createSelector(selectedOpenedClaims, claims => {
    if (claims && claims.get('countClaims')) {
      return claims.get('countClaims');
    }
    return 0;
  });

export const makeSelectSagisLawyerAssignedClaims = () =>
  createSelector(selectedOpenedClaims, sagisLaywerAssignment => {
    if (
      sagisLaywerAssignment &&
      sagisLaywerAssignment.get('sagisLawyerAssignedClaims')
    ) {
      return sagisLaywerAssignment.get('sagisLawyerAssignedClaims').toJS();
    }
    return [];
  });
